<template>
  <div class="m-card-line" :class="{ 'is-strong': strong }">
    <span class="m-card-line__label">{{ label }}</span>
    <span class="m-card-line__value"><slot /></span>
  </div>
</template>

<script>
/**
 * Un renglón «Etiqueta: valor» dentro de MobileRecordCard. El mismo formato que
 * las tarjetas del listado general, para las pantallas que arman sus tarjetas
 * a mano (pagos, cobros, gastos, filas del detalle).
 */
export default {
  name: "MobileCardLine",
  props: {
    label: { type: String, required: true },
    /** El dato principal de la tarjeta (un monto): más oscuro y en negrita. */
    strong: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.m-card-line {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.1rem 0;
}

.m-card-line__label {
  flex-shrink: 0;
  max-width: 42%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.m-card-line__label::after {
  content: ":";
}

.m-card-line__value {
  flex: 1;
  min-width: 0;
  color: var(--m-text);
  overflow-wrap: anywhere;
}

.m-card-line.is-strong .m-card-line__value {
  font-weight: 700;
}
</style>
